import { select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryParams } from '../../../../models';
import { selectFilterFeature } from '../../feature-selector';

export const selectFilterRelatedQueryParamsObject = pipe(
  select(selectFilterFeature),
  map((dataFilterState) => {
    const result: { [fieldId: string]: Set<string> } = {};

    const initializedFilterInstanceStates = Object.values(dataFilterState.dataFilter)
      .filter((filterInstanceState) => filterInstanceState.filterState.isInitialized)
      .filter((filterInstanceState) => !filterInstanceState.queryParamsDisabled);

    const allFieldsFromAllInstances = initializedFilterInstanceStates.flatMap((filterInstanceState) => {
      return Object.values(filterInstanceState.filterState.fieldsState || {}).filter(
        (fieldState) => !fieldState.notTrackedInQueryParams && !filterInstanceState.filterState.fieldDataLoadingState[fieldState.id]
      );
    });

    allFieldsFromAllInstances.forEach((fieldState) => {
      Object.values(fieldState.options)
        .filter((opt) => !opt.notTrackedInQueryParams)
        .forEach((trackedOption) => {
          let fieldSet = result[trackedOption.fieldId];

          if (!fieldSet) {
            result[trackedOption.fieldId] = new Set<string>();
            fieldSet = result[trackedOption.fieldId];
          }

          if (trackedOption.isChecked) {
            fieldSet.add(trackedOption.id);
          }
        });
    });

    initializedFilterInstanceStates.forEach((filterInstanceState) => {
      result[QueryParams.search] =
        filterInstanceState.searchState.searchedValue ?
          new Set<string>([filterInstanceState.searchState.searchedValue]) : new Set<string>();

      if (filterInstanceState.sortState.sortOptionId) {
        result[QueryParams.sortBy] = new Set<string>([filterInstanceState.sortState.sortOptionId]);
      }

      if (filterInstanceState.sortState.sortDirection && filterInstanceState.sortState.sortOptionId !== null) {
        result[QueryParams.sortDirection] = new Set<string>([filterInstanceState.sortState.sortDirection]);
      }
    });

    return result;
  })
);
